import { render, staticRenderFns } from "./RevenueOpportunities.vue?vue&type=template&id=6f368fee&scoped=true"
import script from "./RevenueOpportunities.vue?vue&type=script&lang=js"
export * from "./RevenueOpportunities.vue?vue&type=script&lang=js"
import style0 from "./RevenueOpportunities.vue?vue&type=style&index=0&id=6f368fee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f368fee",
  null
  
)

export default component.exports